import {debounceTime, forkJoin, map, mergeMap, Subject} from "../_snowpack/pkg/rxjs.js";
import {INITIAL_INPUT_DATA} from "../constants.js";
import {geocode, irradiance} from "./maps.js";
const subject = new Subject();
let state = INITIAL_INPUT_DATA.location;
const getLocation = (location) => {
  const url = new URL(window.location.href);
  const lngParam = url.searchParams.get("long");
  const latParam = url.searchParams.get("lat");
  if (lngParam && latParam) {
    return {lat: parseFloat(latParam), lng: parseFloat(lngParam)};
  }
  return location;
};
export const mapStore = {
  subscribe: (setState) => {
    subject.pipe(debounceTime(500), mergeMap(({location, geoEnabled}) => forkJoin([
      geocode(getLocation(location)),
      irradiance(getLocation(location)),
      Promise.resolve(geoEnabled)
    ])), map(([geo, info, enabled]) => ({
      location: {lat: getLocation(geo.geometry.location).lat, lng: getLocation(geo.geometry.location).lng},
      geoEnabled: enabled,
      address: geo.formatted_address,
      info
    }))).subscribe(setState);
  },
  setLocation: (location, geoEnabled) => {
    state = {...state, location, geoEnabled};
    subject.next(state);
  },
  initialState: INITIAL_INPUT_DATA.pvOut
};
